module.exports = __webpack_public_path__ + "media/images/icon-checkbox-on-bac0ee64360eecbb8b180ae68e4d9040.svg";